<template src="./html/EditContent.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'
	import Operations from './../../operations/layout/Operations.vue'
	import AttributeComposer from './AttributeComposer.vue'
	import AttributeFormula from './AttributeFormula.vue'
	import Extras from './../../extras/layout/Extras.vue'
	import Profit from './Profit'

	export default {
		props: ['user', 'isAuth', 'item', 'product', 'main'],
		components: {
			'multiselect': Multiselect,
			'operations': Operations,
			'attribute-composer': AttributeComposer,
			'formula': AttributeFormula,
			'extras': Extras,
			'profit': Profit,
		},
		data () {
			return {
				hidden: false,
				childs: [],
				parent: null,
				viewAttribute: null,

				list: null,

				searchAttributeValuesLoading: false,
				valuesMultiselectSearch: [],
				options: null,
				values: null,

				alerts: {
					total_measurement_unit: {
						min: null,
						max: null,
					},
					quantity: {
						min: null,
						max: null,
					},
				}
			}
		},
		created() {
			if(this.product) {
				if(this.product.parent) {
					var parent = null
					if(this.item.products) {
						if(this.item.products.length) {
							var that = this
							var parent = this.item.products.find(function(element) {
								return element.id == that.product.parent.id
							})
						}
					}
					this.parent = parent
					this.hidden = true
				}
			}
			//-- Check product alerts
			this.checkAlertMeasurement()
			this.checkAlertQuantity()
		},
		watch: {
			'product.title'() {
				if(this.product.title) {
					this.$emit('hasErrors', false)
				} else {
					this.$emit('hasErrors', true)
				}
			},
			hidden () {
				if(!this.hidden) {
					this.product.parent_id = null
					this.product.parent = null
				}

				var that = this
				this.childs = []

				if(this.product) {
					if(this.item) {
						if(this.item.products) {
							if(this.item.products.length) {
								this.childs = Object.assign([], this.item.products)
							}
						}
					}

					if(this.childs.length) {
						var that = this
						this.childs = this.childs.filter(
							product => that.product.id != product.id
						)
					}
				}
			},
			parent () {
				if(this.parent) {
					this.product.parent = this.parent
					this.product.parent_id = this.parent.id
					this.product.quantity = this.parent.quantity
				} else {
					this.hidden = false
				}
			},
			'product.purchase_base_price' () {
				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
			'product.base_price' () {
				this.product.base_price = this.$options.filters.checkDecimals(this.product.base_price)
				this.calculateSave()
				this.calculatePrice()
				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
			'product.total_measurement_unit' () {
				this.product.total_measurement_unit = this.$options.filters.checkDecimals(this.product.total_measurement_unit)
				this.calculateTotalMeasurementUnitQuantity()

				this.calculateTotal()
				this.calculateTotalPriceQuantity()

				this.calculatePurchaseTotal()
				this.calculatePurchaseTotalPriceQuantity()

				this.calculateTotalTaxes()

				this.checkAlertMeasurement()

				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
			'product.quantity' () {
				this.product.quantity = this.toInteger(this.product.quantity)
				this.calculateTotalMeasurementUnitQuantity()

				this.calculateTotalTaxes()
				this.calculateAmount()
				this.calculateTotal()
				this.calculateTotalPriceQuantity()

				this.calculatePurchaseTotalTaxes()
				this.calculatePurchaseAmount()
				this.calculatePurchaseTotal()
				this.calculatePurchaseTotalPriceQuantity()

				this.changeInheritedQuantity()

				this.checkAlertQuantity()

				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
			'product.price' () {
				this.calculateTaxes()
				this.calculatePurchaseTaxes()
				this.calculateAmount()
				this.calculateTotal()
				this.calculateTotalPriceQuantity()
				this.calculateTotalTaxes()

				this.$nextTick( () => this.$refs.profit.calculateProfit())
			},
		},
		methods: {
			reload() {
				this.$emit('reload')
				this.calculateTotal()
				this.calculateTotalPriceQuantity()
				this.calculateTotalTaxes()
			},
			quantityIsEmpty() {
				if(!this.product.quantity) {
					this.product.quantity = 1
				}
			},
			toInteger(value) {
				if(value) {
					if(isNaN(value)) {
						return 1
					} else {
						var stringNumber = String(value)
						stringNumber = stringNumber.replace(',', '')
						stringNumber = stringNumber.replace('.', '')
						value = Number(stringNumber)
						return parseInt(value)
					}
				}
				return value
			},
			operation(attribute, product) {
				this.calculate(attribute, product)
				this.inherit(attribute, product)
			},
			//--
			calculateTotalMeasurementUnitQuantity() {
				if(this.product.total_measurement_unit) {
					var total_measurement_unit = parseFloat(this.product.total_measurement_unit)
				} else {
					var total_measurement_unit = 1
				}

				if(this.product.quantity) {
					var quantity = parseInt(this.product.quantity)
				} else {
					var quantity = 1
				}

				var total_measurement_unit_quantity = total_measurement_unit * quantity
				this.product.total_measurement_unit_quantity = parseFloat(total_measurement_unit_quantity).toFixed(2)
			},
			//-- SALES
				calculateDiscount() {
					if(this.product.base_price) {
						var base_price = parseFloat(this.product.base_price)
					} else {
						var base_price = 0
					}

					if(this.product.save) {
						var save = parseFloat(this.product.save)
					} else {
						var save = 0
					}

					if(save > base_price) {
						this.product.save = -Math.abs(save)
					}

					var discount = save * 100 / base_price

					this.product.discount = parseFloat(discount).toFixed(2)
				},
				calculateSave() {
					if(this.product.base_price) {
						var base_price = parseFloat(this.product.base_price)
					} else {
						var base_price = 0
					}

					if(this.product.discount) {
						var discount = parseFloat(this.product.discount)
					} else {
						var discount = 0
					}

					if(this.product.discount > 100) {
						var total = -Math.abs(base_price * discount / 100)
					} else {
						var total = base_price * discount / 100
					}

					this.product.save = parseFloat(total).toFixed(2)
				},
				calculatePrice() {
					if(this.product.base_price) {
						var base_price = parseFloat(this.product.base_price)
					} else {
						var base_price = 0
					}

					if(this.product.save) {
						var save = parseFloat(this.product.save)
					} else {
						var save = 0
					}

					var price = base_price - Math.abs(save)

					this.product.price = parseFloat(price).toFixed(2)
				},
				calculateTaxes() {
					if(this.product.tax) {
						if(this.product.price) {
							var price = parseFloat(this.product.price)
						} else {
							var price = 0
						}

						var taxes = price * this.product.tax.value / 100
						this.product.taxes = parseFloat(taxes).toFixed(2)
					} else {
						this.product.taxes = 0
					}
				},
				calculateTotalTaxes() {
					if(this.product.tax) {
						if(this.product.price) {
							var price = parseFloat(this.product.price)
						} else {
							var price = 0
						}

						if(this.product.total_measurement_unit_quantity) {
							var total_measurement_unit_quantity = parseFloat(this.product.total_measurement_unit_quantity).toFixed(2)
						} else {
							var total_measurement_unit_quantity = 1
						}

						var total_taxes = (price * this.product.tax.value / 100) * total_measurement_unit_quantity
						this.product.total_taxes = parseFloat(total_taxes).toFixed(2)
					} else {
						this.product.total_taxes = 0
					}
				},
				calculateAmount() {
					if(this.product.price) {
						var price = parseFloat(this.product.price)
					} else {
						var price = 0
					}

					if(this.product.taxes) {
						var taxes = parseFloat(this.product.taxes)
					} else {
						var taxes = 0
					}

					var amount = price + taxes

					this.product.amount = parseFloat(amount).toFixed(2)
				},
				calculateTotal() {
					if(this.product.amount) {
						var amount = parseFloat(this.product.amount)
					} else {
						var amount = 0
					}

					if(this.product.total_measurement_unit) {
						var total_measurement_unit = parseFloat(this.product.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}

					var total = total_measurement_unit * amount

					if(this.product.extras) {
						if(this.product.extras.length) {
							this.product.extras.forEach(function(extra) {
								if(extra.sale_value) {
									total =  total + parseFloat(extra.sale_value)
								}
							})
						}
					}
					
					this.product.total = parseFloat(total).toFixed(2)
				},
				calculateTotalPriceQuantity() {
					if(this.product.total) {
						var total = parseFloat(this.product.total)
					} else {
						var total = 0
					}

					if(this.product.quantity) {
						var quantity = parseInt(this.product.quantity)
					} else {
						var quantity = 1
					}

					var total_price_quantity = total * quantity
					this.product.total_price_quantity = parseFloat(total_price_quantity).toFixed(2)
				},
				//--EVENTS
					discountChange() {
						this.product.discount = this.$options.filters.checkDecimals(this.product.discount)
						this.calculateSave()
						this.calculatePrice()
					},
					saveChange() {
						this.product.save = this.$options.filters.checkDecimals(this.product.save)
						this.calculateDiscount()
						this.calculatePrice()
					},
			//-- SALES

			//-- PURCHASE
				calculatePurchaseTaxes() {
					if(this.product.tax) {
						if(this.product.purchase_price) {
							var purchase_price = parseFloat(this.product.purchase_price)
						} else {
							var purchase_price = 0
						}
						
						var purchase_taxes = purchase_price * this.product.tax.value / 100
						this.product.purchase_taxes = parseFloat(purchase_taxes).toFixed(2)
					} else {
						this.product.purchase_taxes = 0
					}
				},
				calculatePurchaseTotalTaxes() {
					if(this.product.tax) {
						if(this.product.purchase_price) {
							var purchase_price = parseFloat(this.product.purchase_price)
						} else {
							var purchase_price = 0
						}

						if(this.product.quantity) {
							var quantity = parseInt(this.product.quantity)
						} else {
							var quantity = 1
						}
						
						var purchase_total_taxes = purchase_price * this.product.tax.value / 100 * quantity
						this.product.purchase_total_taxes = parseFloat(purchase_total_taxes).toFixed(2)
					} else {
						this.product.purchase_total_taxes = 0
					}
				},
				calculatePurchaseAmount() {
					if(this.product.purchase_price) {
						var purchase_price = parseFloat(this.product.purchase_price)
					} else {
						var purchase_price = 0
					}

					if(this.product.purchase_taxes) {
						var purchase_taxes = parseFloat(this.product.purchase_taxes)
					} else {
						var purchase_taxes = 0
					}

					var purchase_amount = purchase_price + purchase_taxes

					this.product.purchase_amount = parseFloat(purchase_amount).toFixed(2)
				},
				calculatePurchaseTotal() {
					if(this.product.purchase_amount) {
						var purchase_amount = parseFloat(this.product.purchase_amount)
					} else {
						var purchase_amount = 0
					}

					if(this.product.total_measurement_unit) {
						var total_measurement_unit = parseFloat(this.product.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}

					var purchase_total = purchase_amount * total_measurement_unit

					if(this.product.extras) {
						if(this.product.extras.length) {
							this.product.extras.forEach(function(extra) {
								if(extra.purchase_value) {
									purchase_total =  purchase_total + parseFloat(extra.purchase_value)
								}
							})
						}
					}

					this.product.purchase_total = parseFloat(purchase_total).toFixed(2)
				},
				calculatePurchaseTotalPriceQuantity() {
					if(this.product.purchase_total) {
						var purchase_total = parseFloat(this.product.purchase_total)
					} else {
						var purchase_total = 0
					}

					if(this.product.quantity) {
						var quantity = parseInt(this.product.quantity)
					} else {
						var quantity = 1
					}

					var purchase_total_price_quantity = purchase_total * quantity
					this.product.purchase_total_price_quantity = parseFloat(purchase_total_price_quantity).toFixed(2)
				},
			//-- PURCHASE
			openViewAttribute(attribute) {
				var loading = Ladda.create(document.querySelector('#view-all-attribute-values-' + attribute.id))
				loading.start()
				this.viewAttribute = attribute
				this.$http.get('admin/management/products/storages/' + this.viewAttribute.product_storage_id + '/attributes/' + this.viewAttribute.id  + '/values')
				.then(response => {
					loading.stop()
					this.options = response.body.options
					this.values = response.body.values
					this.filter()
					var modal = $('#modal-attribute')
					modal.modal('show')
				})
				/*/
				this.viewAttribute = attribute
				this.filter()
				var modal = $('#modal-attribute')
				modal.modal('show')*/
			},
			closeModalAttributes() {
				var modal = $('#modal-attribute')
				modal.modal('hide')
			},
			filter() {
				var that = this
				if(this.options) {
					if(this.options.length) {
						this.options.forEach(function(option) {
							that.$set(option, 'selected', false)
						})

						if(this.values) {
							if(this.values.length) {
								this.options.forEach(function(option) {
									var found = that.values.find(function(value) {
										return option.id == value.id;
									})
									if(found) {
										option.selected = true
									} else {
										option.selected = false
									}
								})
							}
						}
					}
				}
			},
			quitValue(value) {
				value.selected = false
				var option = this.values.find(function(element) {
					return element.id == value.id
				})
				if(option) {
					let index = this.values.indexOf(option)
					this.$delete(this.values, index)
					this.removeAttributeValue(value, this.viewAttribute)
				}
			},

			addValue(value) {
				value.selected = true
				var selected = Object.assign({}, value)
				this.values.push(selected)
				this.addAttributeValue(value, this.viewAttribute)
			},
			attributesUpdated(attributes) {
				this.product.attribute_storages = attributes
				this.operation()

				this.calculateTotal()
				this.calculateTotalPriceQuantity()

				this.calculatePurchaseTotal()
				this.calculatePurchaseTotalPriceQuantity()
			},
			calculatePrices() {
				this.operation()
				this.calculateTotalMeasurementUnitQuantity()

				this.calculateTotal()
				this.calculateTotalPriceQuantity()

				this.calculatePurchaseTotal()
				this.calculatePurchaseTotalPriceQuantity()
			},
			changeAttributeValue(attribute) {
				this.calculateTotalMeasurementUnit()
			},
			attributeFormulaUpdated(attribute) {
				this.$emit('reload')
				this.operation(attribute)

				this.calculateTotal()
				this.calculateTotalPriceQuantity()

				this.calculatePurchaseTotal()
				this.calculatePurchaseTotalPriceQuantity()
			},
			createFormula(attribute) {
				var that =  this
				var value = null
				if(attribute.value) {
					if(attribute.product_attribute_type_field_id == 1) {
						value = attribute.value.decimal_value
					}
					if(attribute.product_attribute_type_field_id == 2) {
						value = attribute.value.integer_value
					}
				}
				var formula = {
					value: 1,
					product_operation_id: 2,
					total: value,
					product_attribute_storage_id: attribute.id
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.formula_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/products/attribute/storage/formula', formula)
							.then(response => {
								var attributes = response.body.data
								that.product.attribute_storages = attributes
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
								that.$emit('reload')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			changeInherit(attribute) {
				if(attribute.inherit) {
					this.$emit('resetValuesInherit', attribute)
				}
			},
			inherit(attribute) {
				var value = null
				if(attribute) {
					var product_attribute_list_id = attribute.product_attribute_list_id
					if(attribute.formula) {
						value = attribute.formula.total
					} else {
						if(attribute.product_attribute_type_field_id == 1) {
							if(attribute.value) {
								value = attribute.value.decimal_value
							}
						}
						if(attribute.product_attribute_type_field_id == 2) {
							if(attribute.value) {
								value = attribute.value.integer_value
							}
						}
						if(attribute.product_attribute_type_field_id == 3) {
							if(attribute.value) {
								value = attribute.value.string_value
							}
						}
					}
				}
				var that = this
				if(this.product.products) {
					if(this.product.products.length){
						this.product.products.forEach(function(product) {
							if(product.attribute_storages) {
								if(product.attribute_storages.length) {
									product.attribute_storages.forEach(function(attribute) {
										if(attribute.inherit) {
											if(attribute.product_attribute_list_id == product_attribute_list_id) {
												that.changeInheritedValue(attribute, value, product)
											}
										}
									})
								}
							}
						})
					}
				}
			},
			changeInheritedValue(attribute, value, product) {
				if(attribute.product_attribute_type_field_id == 1) {
					if(attribute.value) {
						attribute.value.decimal_value = value
					}
				}
				if(attribute.product_attribute_type_field_id == 2) {
					if(attribute.value) {
						attribute.value.integer_value = value
					}
				}
				if(attribute.product_attribute_type_field_id == 4) {
					if(attribute.value) {
						attribute.value.string_value = value
					}
				}
				this.calculate(attribute, product)
			},
			calculate(attribute, product) {
				if(attribute) {
					this.calculateChildProduct(attribute, product)
				}
				this.calculateTotalMeasurementunit(product)
			},
			calculateTotalMeasurementunit(product) {
				if(product) {
					var that = this
					if(product.product_operation_id == 1) {
						var total = 0;
					}

					if(product.product_operation_id == 2) {
						var total = 1;
					}
					product.attribute_storages.map(function(attribute) {
						if(attribute.operation) {
							if(attribute.product_attribute_type_field_id == 1) {
								if(attribute.value.decimal_value) {
									attribute.value.decimal_value = that.$options.filters.checkDecimals(attribute.value.decimal_value)
								} else {
									attribute.value.decimal_value = 1
								}
								var value = parseFloat(attribute.value.decimal_value)
							}

							if(attribute.product_attribute_type_field_id == 2) {
								attribute.value.integer_value = that.$options.filters.checkDecimals(attribute.value.integer_value)
								var value = parseFloat(ttribute.value.integer_value)
							}
							
							if(attribute.formula) {
								if(attribute.formula.product_operation_id == 1) {
									var formula_total = value + parseFloat(attribute.formula.value)
								}
								if(attribute.formula.product_operation_id == 2) {
									var formula_total = value * parseFloat(attribute.formula.value)
								}
								attribute.formula.total = parseFloat(formula_total).toFixed(2)
								value = parseFloat(attribute.formula.total)
							}

							if(product.product_operation_id == 1) {
								total = total + value
							}
							if(product.product_operation_id == 2) {
								total = total * value
							}
						}
					})
					if(product.measurement_unit) {
						if(product.measurement_unit.operable) {
							product.total_measurement_unit = parseFloat(total).toFixed(2)
						}
					}
				}
			},
			calculateChildProduct(attribute, product) {
				if(attribute.product_attribute_storage_id) {
					var parent = null
					if(product) {
						product.attribute_storages.find(function(element) {
							if(element.id == attribute.product_attribute_storage_id) {
								parent = element
							}

						})
					}
					if(parent) {
						if(parent.childs) {
							if(parent.childs.length) {
								parent.childs.find(function(element, key) {
									if(element.id == attribute.id) {
										parent.childs[key] = attribute
									}

								})

								var operation = ''

								parent.childs.forEach(function(attr, key) {
									var value = null
									if(attr.product_attribute_type_field_id == 1) {
										if(attr.value) {
											value = attr.value.decimal_value
										}
									}
									if(attr.product_attribute_type_field_id == 2) {
										if(attr.value) {
											value = attr.value.integer_value
										}
									}

									if(value) {
										operation += value
										if(parent.childs.length - 1 > key) {
											operation += parent.operator.symbol
										}
									}
								})
								if(operation) {
									var total = eval(operation)
									if(parent.product_attribute_type_field_id == 1) {
										parent.value.decimal_value = Number(parseFloat(total).toFixed(2))
									}
									if(parent.product_attribute_type_field_id == 2) {
										parent.value.integer_value = Number(total)
									}
								}
							}
						}
						this.inherit(parent)
					}
				}
			},
			changeInheritedQuantity() {
				var quantity = this.product.quantity
				if(this.product.products) {
					if(this.product.products.length){
						this.product.products.forEach(function(product) {
							product.quantity = quantity
						})
					}
				}
			},
			changePriceList() {
				if(this.list) {
					this.product.base_price = parseFloat(this.list.total).toFixed(2)
				} else {
					this.product.base_price = 0
				}
			},
			changeBasePrice() {
				this.list = null
			},
			//--
			removeAttributeValue(value, attribute) {
				if(value) {
					this.$http.get('admin/management/products/storages/' + attribute.product_storage_id + '/attributes/' + attribute.id  + '/destroy/value/' + value.id)
					.then(response => {
						let index = attribute.value_lists.indexOf(value)
						attribute.value_lists.splice(index, 1)
						this.filter()
						this.$notify({
							group: 'topRight',
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					})
				}
			},
			addAttributeValue(value, attribute) {
				this.$http.get('admin/management/products/storages/' + attribute.product_storage_id + '/attributes/' + attribute.id  + '/add/value/' + value.id)
				.then(response => {
					attribute.value_lists.push(value)
					this.filter()
					this.clearSearchAttributeValues()
					this.$notify({
						group: 'topRight',
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				})
			},
			searchAttributeValues(query, attribute) {
				this.clearSearchAttributeValues()
				this.searchAttributeValuesLoading = true
				var data = {
					text: query,
				}
				this.$http.post('admin/management/products/storages/' + attribute.product_storage_id + '/attributes/' + attribute.id  + '/seacrh/values', data)
				.then(response => {
					this.valuesMultiselectSearch = response.body
					this.searchAttributeValuesLoading = false
				})
			},
			clearSearchAttributeValues() {
				this.valuesMultiselectSearch = []
			},
			checkAlertMeasurement() {
				if(this.product.origin) {
					if(this.product.origin.alerts) {
						if(this.product.origin.alerts.length) {
							var alerts = this.product.origin.alerts.filter(function(alert) {
								return alert.product_alert_type_id == 1
							})
							if(alerts) {
								if(alerts.length) {
									var that = this
									alerts.forEach(function(alert) {
										if(alert.min) {
											var min = parseFloat(alert.min)
											that.alerts.total_measurement_unit.min = null
											if(that.product.total_measurement_unit < min) {
												that.alerts.total_measurement_unit.min = that.$t('resources.products.alerts.min_value') + ': ' + alert.min
											}
										}
										if(alert.max) {
											var max = parseFloat(alert.max)
											that.alerts.total_measurement_unit.max = null
											if(that.product.total_measurement_unit > max) {
												that.alerts.total_measurement_unit.max = that.$t('resources.products.alerts.max_value') + ': ' + alert.max
											}
										}
									})
								}
							}
						}
					}
				}
			},
			checkAlertQuantity() {
				if(this.product.origin) {
					if(this.product.origin.alerts) {
						if(this.product.origin.alerts.length) {
							var alerts = this.product.origin.alerts.filter(function(alert) {
								return alert.product_alert_type_id == 2
							})
							if(alerts) {
								if(alerts.length) {
									var that = this
									alerts.forEach(function(alert) {
										if(alert.min) {
											var min = parseFloat(alert.min)
											that.alerts.quantity.min = null
											if(that.product.quantity < min) {
												that.alerts.quantity.min = that.$t('resources.products.alerts.min_value') + ': ' + alert.min
											}
										}
										if(alert.max) {
											var max = parseFloat(alert.max)
											that.alerts.quantity.max = null
											if(that.product.quantity > max) {
												that.alerts.quantity.max = that.$t('resources.products.alerts.max_value') + ': ' + alert.max
											}
										}
									})
								}
							}
						}
					}
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/EditContent.vue